import React from "react";
import { TitleWrapperStyled, TitleStyled, styles } from "./styles";

// react plugin for creating charts
import { Bar, Line } from "react-chartjs-2";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// core components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const CardGraph = ({
  title,
  height = 100,
  hasGoBack = false,
  isVertical = false,
  data,
  onChangePage,
  ...props
}) => {
  const classes = useStyles();

  return (
    <>
      <Card>
        <CardHeader className={classes.cardHeader} icon>
          <TitleWrapperStyled>
            <TitleStyled>{title}</TitleStyled>
            {hasGoBack && (
              <Button
                justIcon
                round
                color="info"
                onClick={() => (onChangePage ? onChangePage() : null)}
              >
                <ArrowBackIcon className={classes.buttonIcon} />
              </Button>
            )}
          </TitleWrapperStyled>
        </CardHeader>
        {data && (
          <CardBody>
            {isVertical ? (
              <Line height={height} data={data} {...props} />
            ) : (
              <Bar height={height} data={data} {...props} />
            )}
          </CardBody>
        )}
      </Card>
    </>
  );
};

export default React.memo(CardGraph);
